import axios from 'axios'
import qs from 'qs'
import { Toast } from 'mint-ui'
import Cookies from 'js-cookie'
import i18n from '../pages/recharge/i18n/i18n'

function AddressParameter(name) {
	var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
	var r = window.location.search.substr(1).match(reg)
	if (r != null) return unescape(r[2])
	return null
}
let ua = navigator.userAgent

function isAndroid() {
	return ua.indexOf('Android') > 0
}

function isIOS() {
	return /(iPhone|iPad|iPod)/i.test(ua)
}
// 创建axios实例
const service = axios.create({
	baseURL: process.env.VUE_APP_API, // api的base_url
	timeout: location.pathname.includes('recharge.html') ? 10000 : 5000, // 请求超时时间
})

service.defaults.headers['Content-Type'] =
	'application/x-www-form-urlencoded;charset=UTF-8'
// request拦截器
service.interceptors.request.use(
	(config) => {
		if (config.method == 'get') {
			config.params = {
				...config.params,
			}
		} else {
			config.data = config.data
		}
		// 先从parameter中取token 如果取不到从header中取
		config.headers['token'] =
			encodeURI(AddressParameter('token')) || Cookies.get('psdToken')
		return config
	},
	(error) => {
		console.log(error) // for debug
		Promise.reject(error)
	}
)

// response拦截器
service.interceptors.response.use(
	// response => response,
	(response) => {
		const res = response
		// 一元购支付宝支付拦截（支付宝返回的信息直接在res.data中）
		if (
			res.config.method == 'post' &&
			res.config.url.indexOf('h5/act/coin/recharge') != -1
		) {
			return response
		}
		if (res.data.code !== 200) {
			if (res.data.errorCode == '1000190') {
				Toast({
					message: i18n.t('task.noRecharge'),
					position: 'bottom',
					duration: 2000,
				})
				return
			}
			if (res.data.errorCode == 1000195) {
				Toast({
					message: res.data.errorMsg,
					position: 'bottom',
					duration: 2000,
				})
			} else if (res.data.errorCode == '1000147') {
				Toast({
					message: 'user does not exist',
					position: 'bottom',
					duration: 2000,
				})
			} else if (
				res.data.errorCode != 10002 &&
				res.data.errorCode != 610004 &&
				res.data.errorCode != 90001 &&
				res.data.errorCode != '191001'
			) {
				Toast({
					message: res.data.errorMsg,
					position: 'bottom',
					duration: 2000,
				})
			} else if (res.data.errorCode == 20002) {
				if (isIOS()) {
					window.location.href =
						'mediator://?module=User&action=logout'
				} else if (isAndroid()) {
					window.android.logout(
						{
							message: res.data.errorMsg,
						},
						function () {}
					)
				}
			}
			return Promise.reject(res.data)
		} else {
			return response
		}
	},
	(error) => {
		console.log('err' + error) // for debug
		var errors = error.toString()
		Toast({
			message: error,
			position: 'bottom',
			duration: 2000,
		})
		return Promise.reject(error)
	}
)

export default service
